<template>
  <b-card>
    <b-row>
      <b-col md="4">
        <b-form-group>
          <b-form-select
            v-model="filter2"
            :options="select.filterOptions"
            required
            class="input-new"
            @change="resetFilter"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-input-group v-if="filter2 === '1'">
          <b-form-input
            v-model="form.date"
            type="date"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
            @click="resetIndex"
          ></b-form-input>
        </b-input-group>
        <b-input-group v-else-if="filter2 === '2'">
          <b-form-input
            v-model="form.outlet_name"
            type="search"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
            @click="resetIndex"
          ></b-form-input>
        </b-input-group>
        <b-input-group v-else-if="filter2 === '3'">
          <b-form-input
            v-model="form.main_outlet_name"
            type="search"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
            @click="resetIndex"
          ></b-form-input>
        </b-input-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <b-button
            variant="primary"
            class="input-new"
            v-if="filter2 !== null"
            @click="onClickSearch"
            >SEARCH</b-button
          >
          &nbsp;&nbsp;&nbsp;
          <b-button
            variant="warning"
            class="input-new"
            v-if="filter2 !== null"
            @click="clearFilter"
            >CLEAR</b-button
          >
        </b-form-group>
      </b-col>
    </b-row>

    <!-- TABLE -->
    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
      id="my-table"
    >
      <template v-slot:cell(index)="data">
        {{ pagination.startIndex + data.index }}
      </template>

      <template v-slot:cell(date)="data">
        {{ moment(data.value).format("DD/MM/YYYY") }}
      </template>

      <template v-slot:cell(action)="data">
        <span>
          <b-button
            variant="primary"
            size="sm"
            @click="onClickView(data.item.id)"
          >
            VIEW
          </b-button>
        </span>
      </template>
    </b-table>
    <b-pagination
      v-model="pagination.current"
      :total-rows="pagination.total"
      :per-page="pagination.perPage"
      @change="onChangePage"
    ></b-pagination>
  </b-card>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      moment: moment,
      pro_cat: "1",
      items: [],
      form: {
        id: null,
        date: null,
        outlet_name: null,
        main_outlet_name: null,
        page: 1
      },
      pagination: {
        total: 0,
        current: 1,
        perPage: 10,
        startIndex: 0
      },
      select: {
        filterOptions: [
          { text: "Please Select", value: null },
          { text: "Date", value: "1" },
          { text: "Outlet Name", value: "2" },
          { text: "Outlet Category", value: "3" }
        ]
      },
      indexsearch: 1,
      filter2: null
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  mounted() {},
  created() {
    this.getStockout();
  },
  props: {
    fields: {
      type: Array,
      required: true
    }
  },
  methods: {
    onClickView(id) {
      this.$router.push({
        path: `stockout_view_user?id=${id}&cat=1`
      });
    },
    resetFilter() {
      this.form.date = null;
      this.form.outlet_name = null;
      this.form.main_outlet_name = null;
    },
    clearFilter() {
      this.filter2 = null;
      this.form.date = null;
      this.form.outlet_name = null;
      this.form.main_outlet_name = null;
      this.getStockout();
    },
    onClickSearch() {
      this.form.page = this.indexsearch;
      this.form.id = this.$route.query.id;
      if (this.filter2 === null) {
        this.getStockout();
      } else {
        this.$store.dispatch("searchStockout", this.form).then(res => {
          this.items = [];
          if (res.data.response.code === 100) {
            res.data.data.data.forEach(element => {
              let outletCat;
              if (element.outlet !== null) {
                outletCat = element.outlet.name;
              }

              this.items.push({
                name: element.outlet_name,
                category: outletCat,
                date: element.date,
                id: element.stock_id,
                type: element.type,
                status: element.status_details.desc,
                status_id: element.status
              });
            });
          }
          this.pagination.total = res.data.data.total;
          this.pagination.current = res.data.data.current_page;
          this.pagination.perPage = res.data.data.per_page;
          this.pagination.startIndex = res.data.data.from;
          this.indexsearch = res.data.data.current_page;
        });
      }
    },
    getStockout() {
      this.$store
        .dispatch("getStockout", {
          user_id: this.$route.query.id,
          page: this.pagination.current
        })
        .then(res => {
          this.items = [];
          if (res.data.response.code === 100) {
            res.data.data.data.forEach(element => {
              let outletCat;
              if (element.outlet !== null) {
                outletCat = element.outlet.name;
              }
              this.items.push({
                name: element.outlethistory.outlet_name,
                category: outletCat,
                date: element.date,
                id: element.stock_id,
                type: element.type,
                status: element.status_details.desc,
                status_id: element.status
              });
            });
          }
          this.pagination.total = res.data.data.total;
          this.pagination.current = res.data.data.current_page;
          this.pagination.perPage = res.data.data.per_page;
          this.pagination.startIndex = res.data.data.from;
        });
    },
    onChangePage(index) {
      this.pagination.current = index;
      if (this.filter2 === null) {
        this.getStockout();
      } else {
        this.indexsearch =
          this.pagination.current !== this.indexsearch
            ? this.pagination.current
            : this.indexsearch++;
        this.onClickSearch();
      }
    },
    resetIndex() {
      this.indexsearch = 1;
    }
  }
};
</script>
<style lang="css" scoped></style>
